import {$api} from "./index";

export const createTracking = async (track) => {
    const {data} = await $api.post('api/tracking', track)
    return data
}

export const fetchTracking = async () => {
    const {data} = await $api.get('api/tracking')
    return data
}

export const deleteTracking = async (id) => {
    const {data} = await $api.delete('api/tracking/' + id)
    return data
}